const getState = state => state.LessonsList.state

const getShareLessonRequest = state => state.LessonsList.shareLessonRequest

const getDeleteLessonDialogId = state => getState(state).deleteLessonDialogId

const isCreateModalOpen = state => getState(state).createModalOpen

const isShareModalOpen = state => getState(state).shareModal.opened

const getShareLessonId = state => getState(state).shareModal.id

export {
  getDeleteLessonDialogId,
  isCreateModalOpen,
  isShareModalOpen,
  getShareLessonRequest,
  getShareLessonId
}
